import { SelectItem } from './SelectIem'

export interface IInteractiveTemplateGetFormRequest {
  formKey: string
}

export interface IInteractiveTemplateGetFormResponse {
  formKey: string
  pages: IInteractiveTemplatePage[]
}

export interface IInteractiveTemplatePostFormRequestResponse {
  name: string
  value: string[]
  type: string
  tablename?: string
  column?: string
  precontent?: string
  postcontent?: string
}

export interface IInteractiveTemplatePostFormRequest {
  formKey: string
  responses: IInteractiveTemplatePostFormRequestResponse[]
}

export interface IInteractiveTemplatePostFormResponse {
  data: string
}

export interface IInteractiveTemplatePage {
  name: string
  sections?: IInteractiveTemplateSection[]
}

export interface IInteractiveTemplateSection {
  name: string
  fields?: IInteractiveTemplateField[]
}

export interface IInteractiveTemplateField {
  className: string
  replacement: string
  type: string
  name: string
  label?: string
  placeholder: string
  values: string[]
  required: boolean
  prerequisite?: string
  expected?: string
  options?: SelectItem[]
  onSelection?: (any) => void
  onChange?: (any) => void
  hidden?: boolean
  hint?: string
  important?: string
  preContent?: string
  postContent?: string
}

export enum InteractiveTemplateFieldType {
  Address = 'address',
  Award = 'award',
  Checkbox = 'checkbox',
  Date = 'date',
  Hidden = 'hidden',
  Instruction = 'instruction',
  Phone = 'phone',
  Email = 'email',
  Radio = 'radio',
  Select = 'select',
  Text = 'text',
  TextArea = 'textarea',
}

export enum FormKey {
  EndOfProbation = 'end-of-probation',
  LetterOfResignation = 'letter-of-resignation',
  WarningLetter = 'warning-letter',
  RequestForRecords = 'request-for-records',
  AnnualLeaveNotice = 'notice-of-requirement-to-take-annual-leave',
  AnnualLeaveAgreement = 'agreement-to-take-annual-leave-in-advance',
}
